'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _templateObject = _taggedTemplateLiteral(['box-sizing:border-box;box-shadow:0 1px 5px 0 rgba(0,0,0,0.2);border-radius:3px;background-color:', ';overflow:hidden;'], ['box-sizing:border-box;box-shadow:0 1px 5px 0 rgba(0,0,0,0.2);border-radius:3px;background-color:', ';overflow:hidden;']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Card = _styledComponents2.default.div(_templateObject, (0, _path3.default)(['theme', 'color', 'white']));

Card.displayName = 'Card';

exports.default = Card;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Card/Card.js
// module id = 474
// module chunks = 4